import { Col, Row } from "antd";
import React from "react";
import logo from "./../images/delicioso-logo.jpg";

export default function ReportHeading({ title }) {
  return (
    <Row>
      <Col span={24}>
        <div className="has-text-centered">
          <span className="has-text-weight-bold">MOM ROSE CHICKEN LECHON</span>{" "}
          <br />
          <br />
          Brgy. Alijis, Bacolod City <br />
          {/* Negros Occidental, 6100 */}
          Tel No. +63 961 993 7041 <br />
          {/* Email: purchasing@advercom.ph */}
        </div>
      </Col>
      <Col span={8} className="has-text-centered m-t-1">
        {title && <div className="report-title">{title.toUpperCase()}</div>}{" "}
      </Col>
    </Row>
  );
}
